<ng-container *ngIf="presentation.renders">
  <button
    *ngIf="interactive; else staticPill"
    type="button"
    class="rcm-pill rcm-pill--interactive"
    [class.rcm-pill--expanded]="expanded"
    [style.background]="presentation.background"
    [style.color]="presentation.foreground"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="expanded ? controls : null"
    (click)="onClick()"
    (mouseenter)="onHover()"
  >
    <nova-icon
      *ngFor="let iconName of presentation.iconNames"
      [name]="iconName"
      size="small"
      class="rcm-pill__icon"
    ></nova-icon>
    <span class="rcm-pill__label" [attr.title]="overflowTitle">{{
      presentation.label
    }}</span>
    <nova-icon
      name="expand_more"
      size="small"
      class="rcm-pill__chevron"
      [class.rcm-pill__chevron--up]="expanded"
    ></nova-icon>
  </button>

  <ng-template #staticPill>
    <span
      class="rcm-pill"
      [style.background]="presentation.background"
      [style.color]="presentation.foreground"
      (mouseenter)="onHover()"
    >
      <nova-icon
        *ngFor="let iconName of presentation.iconNames"
        [name]="iconName"
        size="small"
        class="rcm-pill__icon"
      ></nova-icon>
      <span class="rcm-pill__label" [attr.title]="overflowTitle">{{
        presentation.label
      }}</span>
    </span>
  </ng-template>
</ng-container>
